
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faHeart as faHeartOutline } from '@fortawesome/pro-regular-svg-icons'
import { faHeart } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton } from '@material-ui/core'
import { Tooltip } from '@scoir/tooltips'
import { useSelector } from 'react-redux'

import { selectSavedCareers } from 'store/user'

import { useSaveCareer, useUnsaveCareer } from './services'

interface ISaveActionProps {
  name: string
  soc: string
}

const SaveAction = ({ name, soc }: ISaveActionProps) => {
  const savedCareers = useSelector((store) => selectSavedCareers(store))
  const isCareerSaved = savedCareers.some((savedCareer: { SOC: string }) => soc === savedCareer.SOC)
  const saveCareer = useSaveCareer()
  const unsaveCareer = useUnsaveCareer()

  return (
    <Box
      minWidth="33px"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      {isCareerSaved ? (
        <Tooltip title="Unsave career">
          <IconButton
            size="small"
            color="primary"
            aria-label="unsave career"
            style={{ padding: '12px' }}
            onClick={() => {
              unsaveCareer(soc)
            }}
          >
            <FontAwesomeIcon icon={faHeart as IconDefinition} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Save career">
          <IconButton
            size="small"
            color="primary"
            aria-label="save career"
            style={{ padding: '12px' }}
            onClick={() => {
              saveCareer(soc, name)
            }}
          >
            <FontAwesomeIcon icon={faHeartOutline as IconDefinition} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default SaveAction
